var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 69,
    viewBox: "0 0 87 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6 0.599991L24.4 48.6L20 30.6C25.7333 30.6 30.4 32.2667 34 35.6C37.6 38.9333 39.4 43.5333 39.4 49.4C39.4 55.1333 37.5333 59.8 33.8 63.4C30.2 66.8667 25.6667 68.6 20.2 68.6C14.6 68.6 9.93333 66.8667 6.2 63.4C2.6 59.8 0.8 55.1333 0.8 49.4C0.8 47.6667 0.933334 46 1.2 44.4C1.46667 42.6667 2 40.6667 2.8 38.4C3.6 36.1333 4.73333 33.1333 6.2 29.4L17.8 0.599991H37.6ZM84.8 0.599991L71.6 48.6L67.2 30.6C72.9333 30.6 77.6 32.2667 81.2 35.6C84.8 38.9333 86.6 43.5333 86.6 49.4C86.6 55.1333 84.7333 59.8 81 63.4C77.4 66.8667 72.8667 68.6 67.4 68.6C61.8 68.6 57.1333 66.8667 53.4 63.4C49.8 59.8 48 55.1333 48 49.4C48 47.6667 48.1333 46 48.4 44.4C48.6667 42.6667 49.2 40.6667 50 38.4C50.8 36.1333 51.9333 33.1333 53.4 29.4L65 0.599991H84.8Z",
    fill: "#FF3900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.2b4fa368a77b4820fbbacc3af1abb410.svg";
export { ForwardRef as ReactComponent };